import type { FC, ReactElement, ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import {
    StyledLeadsPageIconWrapper,
    StyledLeadsPageTitle,
    StyledLeadsPageTitleWrapper,
} from "app/pages/sales-intelligence/common-components/layout/leads-styles";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { StyledSubTitle } from "./styles";

const TITLE_TRANSLATABLE: Translatable = {
    key: "si.pages.advanced-search.title",
};

interface PageTitleProps {
    subTitle?: ReactNode;
}

const PageTitle: FC<PageTitleProps> = ({ subTitle }): ReactElement => (
    <StyledLeadsPageTitleWrapper>
        <StyledLeadsPageIconWrapper>
            <SWReactIcons
                iconName="phrases"
                iconColor={colorsPalettes.carbon[400]}
                size="xs"
            />
        </StyledLeadsPageIconWrapper>

        <FlexColumn>
            <I18n
                element={StyledLeadsPageTitle}
                translatable={TITLE_TRANSLATABLE}
            />
            {subTitle ? <StyledSubTitle>{subTitle}</StyledSubTitle> : null}
        </FlexColumn>
    </StyledLeadsPageTitleWrapper>
);

export default PageTitle;
